import moment, { Moment } from 'moment';

export function formatDate<T extends string | Date | Moment>(
  text: T | undefined,
  toFormat: string,
  fromFormat?: string
): string | T {
  if (!text) {
    return text;
  }

  return moment(text, fromFormat).format(toFormat);
}

export function formatExchangeDate(text?: string): string | undefined {
  if (!text) {
    return text;
  }

  return moment(text).format('DD.MM.YYYY dd. HH:mm');
}

export function formatDateToSince(
  dateString: string | Date | undefined
): string | Date {
  if (!dateString) {
    return dateString;
  }

  const now = new Date();
  const date = moment(dateString).toDate();
  const diff = now.getTime() - date.getTime();
  const minutes = Math.floor(diff / 1000 / 60);
  if (minutes < 60) {
    return `${minutes} Minute(n)`;
  }
  const hours = Math.floor(minutes / 60);
  if (hours < 24) {
    return `${hours} Stunde(n)`;
  }
  const days = Math.floor(hours / 24);
  if (days < 7) {
    return `${days} Tage(n)`;
  }
  const weeks = Math.floor(days / 7);
  if (weeks < 4) {
    return `${weeks} Woche(n)`;
  }
  const months = Math.floor(days / 30);
  if (months < 12) {
    return `${months} Monat(e)`;
  }
  const years = Math.floor(days / 365);
  return `${years} Jahr(e)`;
}

export function formatSinceToDate(since: string | undefined): string | Date {
  if (!since) {
    return since;
  }

  const lowerSince = since.toLowerCase();

  if (!lowerSince.startsWith('vor ')) {
    return since;
  }

  const matches = lowerSince.match(
    /vor (\d+)\s*(tage?|wochen?|monate?|jahre?)/
  );

  if (matches) {
    const value = parseInt(matches[1], 10);
    const unit = matches[2];

    const now = new Date();
    let publishedAt: Date;

    switch (unit) {
      case 'tag':
      case 'tage':
        publishedAt = new Date(now.getTime() - value * 24 * 60 * 60 * 1000);
        break;
      case 'woche':
      case 'wochen':
        publishedAt = new Date(now.getTime() - value * 7 * 24 * 60 * 60 * 1000);
        break;
      case 'monat':
      case 'monate':
        publishedAt = new Date(now.setMonth(now.getMonth() - value));
        break;
      case 'jahr':
      case 'jahre':
        publishedAt = new Date(now.setFullYear(now.getFullYear() - value));
        break;
      default:
        return;
    }

    return publishedAt;
  }
}
